import { Fragment } from 'react'

const urlRegExp = 'https://[a-zA-Z0-9-_./=?%]+'
const urlRegExpSplitter = new RegExp(`(\[?${urlRegExp}\]?)`)
const urlRegExpTrimmed = new RegExp(urlRegExp)

export const linkify = (text: string) =>
  text.split(urlRegExpSplitter).map((part, i) =>
    urlRegExpSplitter.test(part) ? (
      <a
        key={i}
        href={part.match(urlRegExpTrimmed)?.join()}
        target="_blank"
        rel="noreferrer"
      >
        {part.match(urlRegExpTrimmed)?.join()}
      </a>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    )
  )

export const splitAndLinkify = (text: string) =>
  text.split('\n').map((line, n) => (
    <Fragment key={n}>
      {linkify(line)}
      {/*<br />*/}
    </Fragment>
  ))

type Props = {
  text: string
}
const parseLinksToJSX = (input: string): (string | JSX.Element)[] => {
  const regex = /\[([^\]]+)\]/g // Match text inside brackets []

  const parts: (string | JSX.Element)[] = []
  let lastIndex = 0

  let match
  while ((match = regex.exec(input)) !== null) {
    const [fullMatch, content] = match
    const [text, url] = content.includes('|')
      ? content.split('|').map(part => part.trim())
      : [content.trim(), content.trim()]

    // Add text before the match as a string
    if (lastIndex < match.index) {
      parts.push(input.substring(lastIndex, match.index))
    }

    // Add the anchor tag as a JSX element
    parts.push(
      <a key={match.index} href={url} target="_blank" rel="noreferrer">
        {text}
      </a>
    )

    lastIndex = regex.lastIndex
  }

  // Add remaining text after the last match
  if (lastIndex < input.length) {
    parts.push(input.substring(lastIndex))
  }

  return parts
}
export const TextWithLinks: React.FC<Props> = ({ text }) => {
  const parsedContent = parseLinksToJSX(text)

  return <>{parsedContent}</>
}
